import type { ComponentProps } from 'react';
import { OwcComponentHeader } from '@one/react';

export type PocComponentHeaderProps = ComponentProps<typeof OwcComponentHeader>;

export const PocComponentHeader: React.FC<PocComponentHeaderProps> = (props) => <OwcComponentHeader {...props} />;
